<template>
  <el-dialog
    :title="`共生成${list.length}个报告`"
    :visible.sync="visible"
    width="640px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClose">
    <el-table
      border=""
      :data="list">
      <el-table-column
        label="样品编号"
        width="80"
        prop="samplenum"></el-table-column>
      <el-table-column
        label="样品名称"
        min-width="120"
        prop="samplename"></el-table-column>
      <el-table-column
        label="企业名称"
        min-width="170"
        prop="prosecutedunits"></el-table-column>
      <el-table-column
        label="检测记录"
        min-width="100">
        <template slot-scope="{ row }">
          <el-popover>
            <el-table
              border=""
              :data="row.items">
              <el-table-column
                width="180"
                label="检测记录唯一编号"
                prop="syscode"> </el-table-column>
              <el-table-column
                label="检测项"
                min-width="100"
                prop="testproject"></el-table-column>
              <!-- <el-table-column
                min-width="60"
                label="判定值">
                <template slot-scope="{ scope }">
                  {{ scope.row.symbol }}{{ scope.row.cov }}{{ scope.row.covunit }}
                </template>
              </el-table-column> -->
              <el-table-column
                label="检测结果值"
                min-width="90"
                prop="testresult"></el-table-column>
              <el-table-column
                label="判定结果"
                min-width="90"
                prop="decisionoutcome"></el-table-column>
            </el-table>
            <el-link
              slot="reference"
              type="primary"
              style="font-size: 12px"
              :underline="false">{{ row.items.length }}条</el-link>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">
        取 消
      </el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">
        确 定
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'ReportModal',
  components: { },
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      list: [],
      ids: []
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.list = []
      this.ids = []
    },
    generateinspectionreport() {
      this.loading = true
      this.$store.dispatch('account/generateinspectionreport', {
        payload: {
          inspectionItemDataIds: this.ids
        },
        success: () => {
          this.loading = false
          this.toggleModal(false)
          this.callback && this.callback()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleSubmit() {
      this.$confirm(`此操作将生成${this.list.length}个快检报告, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.generateinspectionreport()
      })
    },
    init(options = []) {
      this.list = options.list
      this.ids = options.ids
      this.toggleModal(true)
    }
  }
}
</script>
